import React from "react";
import {
  handleChange,
  handleChangeCheck,
  handleChangeNumeral,
} from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonInput from "../../../components/forms/CommonInput";
import CommonCheckboxSimNao from "../../../components/forms/CommonCheckboxSimNao";
import {
  adicionarDiasUteis,
  getProximaDataUtil,
  isDiaUtil,
} from "../../../helpers/mesesHelper";
import CommonSwal from "../../../components/Swal/commonSwal";
import PropTypes from "prop-types";

function SolicitarFeriasModal({
  isOpen,
  setIsOpen,
  valuesHook,
  solicitarFerias,
}) {
  const { values, setValues } = valuesHook;

  React.useEffect(() => {
    if (!values?.inicio_ferias) return;
    const dataInicio = new Date(values.inicio_ferias);

    if (!isDiaUtil(dataInicio, true)) {
      CommonSwal({
        icon: "warning",
        text: "Não é permitido começar as férias dois dias antes de um feriado ou de um dia de folga remunerada.",
      });
      setValues((prevValues) => ({
        ...prevValues,
        fim_ferias: "",
        data_retorno: "",
      }));
      return;
    }

    if (!values?.dias_ferias) return;

    const dataFim = new Date(dataInicio);
    dataFim.setDate(dataFim.getDate() - 1);
    let dias = parseInt(values.dias_ferias);

    if (values.vender_terco_ferias) dias = dias - Math.floor(dias / 3);
    console.log("dias: ", dias)
    dataFim.setDate(dataFim.getDate() + (dias - 1));

    const dataRetorno = new Date(dataFim.toISOString().split("T")[0]);
    dataRetorno.setDate(
      dataFim.getDay() > 4 ? dataRetorno.getDate() : dataRetorno.getDate() + 1
    );

    setValues((prevValues) => ({
      ...prevValues,
      fim_ferias: dataFim.toISOString().split("T")[0],
      data_retorno: getProximaDataUtil(dataRetorno.toISOString().split("T")[0]),
    }));
  }, [
    setValues,
    values.dias_ferias,
    values.inicio_ferias,
    values.vender_terco_ferias,
  ]);

  return (
    <CommonModal
      title={"Solicitar férias"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="md"
      buttons={
        <CommonButton
          key={`solicitar-ferias`}
          onClick={solicitarFerias}
          color="success"
        >
          Confirmar solicitação
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInputDate
            id="inicio_ferias"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.inicio_ferias}
            min={getProximaDataUtil(adicionarDiasUteis())}
            label="Inicio das férias"
            hint="O pagamento das férias deve ocorrer até dois dias antes do início das férias e é proibido que o início das férias seja dois dias antes de feriado ou do final de semana."
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonInput
            id="dias_ferias"
            onChange={(e) => handleChangeNumeral(e, values, setValues)}
            value={values.dias_ferias}
            label="Dias de férias"
            hint="O pagamento das férias deve ocorrer até dois dias antes do início das férias e é proibido que o início das férias seja dois dias antes de feriado ou do final de semana."
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInputDate
            id="fim_ferias"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.fim_ferias}
            label="Fim das férias"
            disabled
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonInputDate
            id="data_retorno"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.data_retorno}
            label="Data de retorno"
            disabled
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <CommonCheckboxSimNao
            label="Colaborador deseja vender 1/3 das férias?"
            id="vender_terco_ferias"
            value={values.vender_terco_ferias}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
          />
        </div>
      </div>
    </CommonModal>
  );
}

SolicitarFeriasModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  solicitarFerias: PropTypes.func.isRequired,
};

export default SolicitarFeriasModal;
